import { motion } from "framer-motion";
import {
  Smartphone,
  Globe,
  Cpu,
  Layout,
  Cloud,
  BookOpen,
  Navigation,
} from "react-feather";

const services = [
  { icon: Smartphone, title: "App Development", desc: "Native & cross-platform mobile apps" },
  { icon: Globe, title: "Web Development", desc: "Scalable, modern web applications" },
  { icon: Cpu, title: "AI Solutions", desc: "Intelligent automation & ML integration" },
  { icon: Layout, title: "UI/UX Design", desc: "Premium interfaces users love" },
  { icon: Cloud, title: "Cloud Services", desc: "AWS, DevOps & infrastructure" },
  { icon: BookOpen, title: "LMS Platforms", desc: "Learning management systems" },
  { icon: Navigation, title: "Ride Booking Systems", desc: "Mobility & fleet management" },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 md:py-32 premium-section-alt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-royal font-semibold text-sm uppercase tracking-widest">Services</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-bold text-white">End-to-End Digital Solutions</h2>
          <p className="mt-4 text-white/60 max-w-2xl mx-auto">
            From concept to deployment — we deliver premium technology services
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              whileHover={{ y: -6, scale: 1.02 }}
              className="group p-6 rounded-2xl premium-glass hover:border-[#2563EB]/30 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-navy to-royal flex items-center justify-center text-white mb-4 group-hover:scale-110 transition-transform">
                <s.icon size={26} />
              </div>
              <h3 className="text-lg font-bold text-white">{s.title}</h3>
              <p className="mt-2 text-white/55 text-sm">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
